import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import Header from './components/Header.jsx';
import Sidebar from './components/Sidebar.jsx';
import LoadingScreen from './components/LoadingScreen.jsx';
import Dashboard from './pages/Dashboard.jsx';
import Utils, { getActiveToolInfo as getActiveToolInfoUtils } from './pages/Utils.jsx';
import Converters, { getActiveToolInfo as getActiveToolInfoConverters } from './pages/Converters.jsx';
import Security, { getActiveToolInfo as getActiveToolInfoSecurity } from './pages/Security.jsx';
import Content from './pages/Content.jsx';
import Domains, { getActiveToolInfo as getActiveToolInfoDomains } from './pages/Domains.jsx';
import Images, { getActiveToolInfo as getActiveToolInfoImages } from './pages/Images.jsx';
import Text, { getActiveToolInfo as getActiveToolInfoText } from './pages/Text.jsx';
import Development, { getActiveToolInfo as getActiveToolInfoDevelopment } from './pages/Development.jsx';
import ApiDocs from './pages/ApiDocs.jsx';
import NotFound from './pages/NotFound.jsx';

function App() {
  const [sidebarOpen, setSidebarOpen] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(true);
  const location = useLocation();

  React.useEffect(() => {
    // Simular tempo de carregamento
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  let headerInfo = {};
  if (location.pathname.startsWith('/utils')) {
    headerInfo = getActiveToolInfoUtils(location);
  } else if (location.pathname.startsWith('/converters')) {
    headerInfo = getActiveToolInfoConverters(location);
  } else if (location.pathname.startsWith('/security')) {
    headerInfo = getActiveToolInfoSecurity(location);
  } else if (location.pathname.startsWith('/domains')) {
    headerInfo = getActiveToolInfoDomains(location);
  } else if (location.pathname.startsWith('/images')) {
    headerInfo = getActiveToolInfoImages(location);
  } else if (location.pathname.startsWith('/text')) {
    headerInfo = getActiveToolInfoText(location);
  } else if (location.pathname.startsWith('/development')) {
    headerInfo = getActiveToolInfoDevelopment(location);
  }

  if (isLoading) {
    return <LoadingScreen />;
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Header onMenuClick={toggleSidebar} category={headerInfo.category} tool={headerInfo.tool} />
      
      <div className="flex">
        <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        
        <main className="flex-1 p-6 lg:p-8 bg-white">
          <AnimatePresence mode="wait">
            <Routes>
              <Route 
                path="/" 
                element={
                  <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -20 }}
                    transition={{ duration: 0.3 }}
                  >
                    <Dashboard />
                  </motion.div>
                } 
              />
              <Route 
                path="/utils/*" 
                element={
                  <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -20 }}
                    transition={{ duration: 0.3 }}
                  >
                    <Utils />
                  </motion.div>
                } 
              />
              <Route 
                path="/converters/*" 
                element={
                  <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -20 }}
                    transition={{ duration: 0.3 }}
                  >
                    <Converters />
                  </motion.div>
                } 
              />
              <Route 
                path="/security/*" 
                element={
                  <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -20 }}
                    transition={{ duration: 0.3 }}
                  >
                    <Security />
                  </motion.div>
                } 
              />
              <Route 
                path="/content/*" 
                element={
                  <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -20 }}
                    transition={{ duration: 0.3 }}
                  >
                    <Content />
                  </motion.div>
                } 
              />
              <Route 
                path="/domains/*" 
                element={
                  <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -20 }}
                    transition={{ duration: 0.3 }}
                  >
                    <Domains />
                  </motion.div>
                } 
              />
              <Route 
                path="/images/*" 
                element={
                  <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -20 }}
                    transition={{ duration: 0.3 }}
                  >
                    <Images />
                  </motion.div>
                } 
              />
              <Route 
                path="/text/*" 
                element={
                  <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -20 }}
                    transition={{ duration: 0.3 }}
                  >
                    <Text />
                  </motion.div>
                } 
              />
              <Route 
                path="/development/*" 
                element={
                  <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -20 }}
                    transition={{ duration: 0.3 }}
                  >
                    <Development />
                  </motion.div>
                } 
              />
              <Route 
                path="/api-docs" 
                element={
                  <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -20 }}
                    transition={{ duration: 0.3 }}
                  >
                    <ApiDocs />
                  </motion.div>
                } 
              />
              <Route 
                path="*" 
                element={
                  <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -20 }}
                    transition={{ duration: 0.3 }}
                  >
                    <NotFound />
                  </motion.div>
                } 
              />
            </Routes>
          </AnimatePresence>
        </main>
      </div>
    </div>
  );
}

export default App; 